import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`
  };
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    display: "flex",
    margin: "0 8px"
  },
  rootNotFlex: {
    margin: "0 8px",
    flexGrow: 1,
    width: "100%"
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    marginRight: theme.spacing()
  },
  tabsHoriz: {
    borderRight: 0,
    backgroundColor: theme.palette.background.paper,
    marginRight: 0
  },
  form: {
    flexGrow: 1,
    padding: `${theme.spacing(2)}px ${theme.spacing(9)}px 0 ${theme.spacing(
      2
    )}px`,
    backgroundColor: theme.palette.background.paper
  },
  label: {
    textTransform: "none",
    alignItems: "flex-start",
    textAlign: "left"
  },
  tabsContainer: {
    minWidth: "264px",
    marginBottom: 0
  },
  tabsContainerHoriz: {
    marginBottom: theme.spacing()
  },
  tabContent: {
    flexGrow: 1
  }
}));

export default function MenuTabs(props) {
  const [orientation, setOrientation] = React.useState(props.orientation);
  const [page, setPage] = React.useState(0);

  const classes = useStyles({ orientation });

  const handleChange = (event, newValue) => {
    setPage(newValue);
  };

  const activePage = props.children[page];

  const tabClasses = { wrapper: classes.label, wrapped: classes.label };

  return (
    <div
      className={
        props.orientation === "horizontal" ? classes.rootNotFlex : classes.root
      }
    >
      <div
        className={
          props.orientation === "horizontal"
            ? classes.tabsContainerHoriz
            : classes.tabsContainer
        }
      >
        <Tabs
          orientation={props.orientation ? props.orientation : "vertical"}
          value={page}
          variant="scrollable"
          scrollButtons="on"
          onChange={handleChange}
          // classes={{ wrapper: classes.label, wrapped: classes.label }}
          className={
            props.orientation === "horizontal"
              ? classes.tabsHoriz
              : classes.tabs
          }
        >
          {props.items &&
            props.items.length > 0 &&
            props.items.map(({ caption, number }) => (
              <Tab
                label={caption}
                {...a11yProps(number)}
                classes={tabClasses}
                key={number}
              />
            ))}
        </Tabs>
      </div>
      <div className={classes.tabContent}>{activePage}</div>
    </div>
  );
}
